<template>
  <teleport to="body">
    <div
      class="frisbuy-mobile-popup"
      :class="{ 'frisbuy-mobile-popup--video-mode': isVideoMode }"
      @click.self="closePopup"
    >
      <button
        class="frisbuy-mobile-popup__close"
        type="button"
        @click="closePopup"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.2959 7.11895C18.6864 6.72842 18.6864 6.09526 18.2959 5.70473C17.9054 5.31421 17.2722 5.31421 16.8817 5.70473L12.0003 10.5861L7.11895 5.70473C6.72842 5.31421 6.09526 5.31421 5.70473 5.70473C5.31421 6.09526 5.31421 6.72842 5.70473 7.11895L10.5861 12.0003L5.70473 16.8817C5.31421 17.2722 5.31421 17.9054 5.70473 18.2959C6.09526 18.6864 6.72842 18.6864 7.11895 18.2959L12.0003 13.4145L16.8817 18.2959C17.2722 18.6864 17.9054 18.6864 18.2959 18.2959C18.6864 17.9054 18.6864 17.2722 18.2959 16.8817L13.4145 12.0003L18.2959 7.11895Z"
            fill="white"
          />
        </svg>
      </button>

      <div class="frisbuy-mobile-popup__header">
        <span>Все фото покупателей</span>
        <span>{{ mediaCounterText }}</span>
      </div>

      <div
        class="frisbuy-mobile-popup__media"
        :class="{ 'frisbuy-mobile-popup__media--video': isVideoMode }"
      >
        <div
          v-if="showSwipeHint"
          class="frisbuy-mobile-popup__swipe-hint"
          aria-hidden="true"
        >
          <span class="frisbuy-mobile-popup__swipe-hint-block"></span>
        </div>

        <Swiper
          class="frisbuy-mobile-popup__swiper"
          :initial-slide="initialSlide"
          @swiper="onSwiperInit"
          @slideChange="onSlideChange"
        >
          <SwiperSlide
            v-for="(media, index) in swiperMediaList"
            :key="`${media.postId}-${
              media.thumbnailUrl || media.imageUrl || index
            }`"
            class="frisbuy-mobile-popup__slide"
            @click="onMediaSlideClick(media, index)"
          >
            <img
              v-if="!media.videoUrl"
              :src="DomainSubstitute(getSlideImage(media, index))"
              @error="(e) => errorSlideImageHandler(e, media, index)"
            />
            <img
              v-else-if="!isVideoPlaying || activeSlideIndex !== index"
              :src="DomainSubstitute(getSlideImage(media, index))"
              @error="(e) => errorSlideImageHandler(e, media, index)"
            />
            <video
              v-if="media.videoUrl"
              v-show="isVideoInterfaceVisible && activeSlideIndex === index"
              :src="media.videoUrl"
              muted
              loop="true"
              playsinline
              :ref="(el) => setVideoRef(el as HTMLVideoElement | null, index)"
              @click.stop="toggleVideoPlayback"
              @pause="pauseVideo"
            ></video>

            <span
              v-if="media.videoUrl && (!isVideoInterfaceVisible || !isVideoPlaying)"
              class="frisbuy-mobile-popup__play-icon"
              @click.stop="playVideo"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <circle
                  cx="24"
                  cy="24"
                  r="16"
                  fill="#212121"
                  fill-opacity="0.2"
                />
                <g opacity="0.8">
                  <path
                    d="M28.1192 22.7772C28.8701 23.2446 28.8701 24.4239 28.1192 24.8912L22.6451 28.2979C21.8999 28.7616 20.9727 28.1756 20.9727 27.2409L20.9727 20.4276C20.9727 19.4928 21.8999 18.9068 22.6451 19.3706L28.1192 22.7772Z"
                    fill="white"
                  />
                  <path
                    d="M34.125 24.0005C34.125 18.4083 29.5921 13.8744 24 13.8742C18.4076 13.8742 13.8737 18.4081 13.8737 24.0005C13.8739 29.5926 18.4078 34.1255 24 34.1255C29.592 34.1252 34.1248 29.5925 34.125 24.0005ZM36.7917 24.0005C36.7914 31.0652 31.0647 36.7919 24 36.7922C16.935 36.7922 11.2073 31.0654 11.207 24.0005C11.207 16.9354 16.9349 11.2075 24 11.2075C31.0649 11.2078 36.7917 16.9355 36.7917 24.0005Z"
                    fill="white"
                  />
                </g>
              </svg>
            </span>
          </SwiperSlide>
        </Swiper>

        <div
          class="frisbuy-mobile-popup__video-overlay"
          :class="{ 'frisbuy-mobile-popup__video-overlay--video': isVideoMode }"
        >
          <div
            class="frisbuy-mobile-popup__info"
            :class="{ 'frisbuy-mobile-popup__info--video': isVideoMode }"
          >
            <CustomerReview
              :customerName="
                props.post.instagramPost.authorUser.fio ||
                `@${props.post.instagramPost.authorUser.username}`
              "
              :reviewDate="props.reviewDate"
              :reviewTime="props.reviewTime"
              :rating="props.post.frisbuyPost.rating"
              :negativeComment="''"
              :positiveComment="''"
              :text="reviewText"
              :isShowMedia="false"
              authorView="popup"
              :sectionsMarginTop="['0', '20px', '30px']"
            >
              <template #topRight>
                <button
                  class="frisbuy-mobile-popup__open-review"
                  type="button"
                  @click="isMobileReviewSheetOpen = true"
                >
                  См. отзыв
                </button>
              </template>
            </CustomerReview>
          </div>

          <PopupReviewMobileVideoControls
            v-if="isVideoMode"
            :videoEl="getActiveVideoElement()"
          />
        </div>
      </div>

      <div
        class="frisbuy-mobile-popup__bottom-layer"
        :class="{ 'frisbuy-mobile-popup__bottom-layer--video': isVideoMode }"
      >
        <PopupReviewMobileMediaSlider
          v-show="!isVideoMode"
          :mediaList="props.allCustomersMediaList"
          :selectedMediaThumbnailUrl="currentMedia?.thumbnailUrl"
          @selectMedia="(media) => selectMedia(media)"
          @requestToLoadCustomersMedia="emit('requestToLoadCustomersMedia')"
        />
      </div>

      <MobileReviewSheet
        :isOpen="isMobileReviewSheetOpen"
        :post="props.post"
        :bestPostIds="props.bestPostIds"
        :reviewIndex="props.selectedPostIndex + 1"
        :reviewDate="props.reviewDate"
        :selectedMediaThumbnailUrl="currentMedia?.thumbnailUrl"
        :mediaList="props.allCustomersMediaList"
        @close="isMobileReviewSheetOpen = false"
        @selectMedia="(media) => selectMedia(media)"
      />
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import CustomerReview from "../CustomerReview.vue";
import MobileReviewSheet from "../MobileReviewSheet.vue";
import PopupReviewMobileMediaSlider from "../PopupReviewMobileMediaSlider.vue";
import PopupReviewMobileVideoControls from "./PopupReviewMobileVideoControls.vue";
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import widgetTypes from "@/common/consts/widgetTypes";
import { imageWithPostId, IMarketplaceReviewsPost } from "../../interfaces";

const props = defineProps<{
  post: IMarketplaceReviewsPost;
  selectedPostIndex: number;
  selectedMediaIndex: number;
  bestPostIds: number[];
  allCustomersMediaList: Array<imageWithPostId>;
  totalMediaCount?: number;
  reviewDate: string;
  reviewTime: string;
}>();

const emit = defineEmits([
  "close",
  "selectPrevPost",
  "selectNextPost",
  "selectPost",
  "sendAnaliticEvent",
  "requestToLoadCustomersMedia",
]);

const isMobileReviewSheetOpen = ref(false);
const isVideoPlaying = ref(false);
const isVideoInterfaceVisible = ref(false);
const videoElements = ref<(HTMLVideoElement | null)[]>([]);
const swiperInstance = ref<any | null>(null);
const slideImageFallbackSteps = ref<Record<string, number>>({});
const activeSlideIndex = ref(0);
const showSwipeHint = ref(false);
const SWIPE_HINT_DURATION_MS = 2880;
let swipeHintTimer: ReturnType<typeof setTimeout> | null = null;
const swiperMediaList = computed<imageWithPostId[]>(() => {
  if (props.allCustomersMediaList.length) {
    return props.allCustomersMediaList;
  }

  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  return props.post.media.map((media) => ({
    ...media,
    postId,
  }));
});

const currentMediaIndex = computed(() => {
  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  const currentMedia = props.post.media[props.selectedMediaIndex];

  return swiperMediaList.value.findIndex((media) => {
    return media.postId === postId && media.imageUrl === currentMedia?.imageUrl;
  });
});

const mediaCounterText = computed(() => {
  const totalMediaCount = props.totalMediaCount ?? swiperMediaList.value.length;

  if (!totalMediaCount) {
    return "0/0";
  }

  const normalizedIndex =
    currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value + 1;
  return `${normalizedIndex}/${totalMediaCount}`;
});
const initialSlide = computed(() =>
  currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value
);

const currentMedia = computed<imageWithPostId>(() => {
  const postMedia = props.post.media[props.selectedMediaIndex];
  return {
    ...postMedia,
    postId:
      props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId,
  };
});

const reviewText = computed(() => props.post.frisbuyPost.text?.trim() || "");
const isVideoMode = computed(
  () => isVideoInterfaceVisible.value && Boolean(currentMedia.value.videoUrl)
);

watch(
  () => [props.post, props.selectedMediaIndex],
  () => {
    isVideoInterfaceVisible.value =
      isVideoInterfaceVisible.value && Boolean(currentMedia.value.videoUrl);
    isVideoPlaying.value =
      isVideoPlaying.value && Boolean(currentMedia.value.videoUrl);
    slideImageFallbackSteps.value = {};

    const targetSlide =
      currentMediaIndex.value < 0 ? 0 : currentMediaIndex.value;
    if (
      swiperInstance.value &&
      swiperInstance.value.activeIndex !== targetSlide
    ) {
      swiperInstance.value.slideTo(targetSlide, 0);
    }
  }
);

function getImageCandidateByStep(media: imageWithPostId, step: number) {
  const candidates = [
    media.imageHighResolutionUrl,
    media.imageUrl,
    media.thumbnailUrl,
  ].filter(Boolean);

  return candidates[step] || "";
}

function getMediaKey(media: imageWithPostId, index: number) {
  return `${media.postId}-${media.thumbnailUrl || media.imageUrl || index}`;
}

function getSlideImage(media: imageWithPostId, index: number) {
  const key = getMediaKey(media, index);
  const step = slideImageFallbackSteps.value[key] || 0;
  return getImageCandidateByStep(media, step);
}

function onSwiperInit(swiper: any) {
  swiperInstance.value = swiper;
  activeSlideIndex.value = swiper.activeIndex || 0;
}

function onSlideChange(swiper: any) {
  activeSlideIndex.value = swiper.activeIndex || 0;
  const selectedMedia = swiperMediaList.value[swiper.activeIndex];
  if (!selectedMedia) return;

  if (isVideoInterfaceVisible.value) {
    pauseAndResetAllVideos();
    const hasVideo = Boolean(selectedMedia.videoUrl);
    isVideoInterfaceVisible.value = hasVideo;
    isVideoPlaying.value = hasVideo;

    if (hasVideo) {
      const nextVideo = getActiveVideoElement();
      nextVideo?.play().catch(() => {
        isVideoPlaying.value = false;
      });
    }
  }

  emit("selectPost", selectedMedia.postId, selectedMedia);
}

function closePopup() {
  emit("close");
}

function selectMedia(media: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  emit("selectPost", media.postId, media);
}

function playVideo() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo) return;

  emit("sendAnaliticEvent", "PlayVideo", {
    provPostId:
      props.post.instagramPost?.frisbuyId ?? props.post.providerPost.frisbuyId,
    fbProduct: props.post.frisbuyPost.id,
    igCode: props.post.instagramPost.shortcode,
  });

  isVideoInterfaceVisible.value = true;
  isVideoPlaying.value = true;
  activeVideo.currentTime = 0;
  activeVideo.play().catch(() => {
    isVideoPlaying.value = false;
  });
}

function resumeVideo() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo) return;

  isVideoInterfaceVisible.value = true;
  activeVideo.play().then(() => {
    isVideoPlaying.value = true;
  }).catch(() => {
    isVideoPlaying.value = false;
  });
}

function toggleVideoPlayback() {
  const activeVideo = getActiveVideoElement();
  if (!activeVideo || !isVideoInterfaceVisible.value) {
    return;
  }

  if (isVideoPlaying.value) {
    activeVideo.pause();
    return;
  }

  resumeVideo();
}

function onMediaSlideClick(media: imageWithPostId, index: number) {
  if (!media.videoUrl || activeSlideIndex.value !== index) {
    return;
  }

  if (!isVideoInterfaceVisible.value) {
    playVideo();
    return;
  }

  if (isVideoPlaying.value) {
    toggleVideoPlayback();
    return;
  }

  resumeVideo();
}

function pauseVideo() {
  isVideoPlaying.value = false;
}

function stopVideo() {
  isVideoPlaying.value = false;
  isVideoInterfaceVisible.value = false;
  pauseAndResetAllVideos();
}

function pauseAndResetAllVideos() {
  videoElements.value.forEach((video) => {
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  });
}

function setVideoRef(el: HTMLVideoElement | null, index: number) {
  videoElements.value[index] = el;
}

function getActiveVideoElement() {
  return videoElements.value[activeSlideIndex.value] || null;
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

onMounted(() => {
  lockWindowScroll();
  slideImageFallbackSteps.value = {};
  activeSlideIndex.value = initialSlide.value;
  showSwipeHint.value = true;
  swipeHintTimer = setTimeout(() => {
    showSwipeHint.value = false;
  }, SWIPE_HINT_DURATION_MS);
});

onBeforeUnmount(() => {
  if (swipeHintTimer) {
    clearTimeout(swipeHintTimer);
    swipeHintTimer = null;
  }
  unlockWindowScroll();
});

function errorSlideImageHandler(
  e: Event,
  media: imageWithPostId,
  index: number
) {
  const key = getMediaKey(media, index);
  const nextStep = (slideImageFallbackSteps.value[key] || 0) + 1;
  const nextImage = getImageCandidateByStep(media, nextStep);
  if (nextImage) {
    slideImageFallbackSteps.value = {
      ...slideImageFallbackSteps.value,
      [key]: nextStep,
    };
    return;
  }

  MediaCatcher(e, 2, widgetTypes.STORY);
}
</script>

<style scoped lang="scss">
.frisbuy-mobile-popup {
  position: fixed;
  inset: 0;
  z-index: 101;
  background: #1f2328;
  color: #ffffff;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
  overflow-x: hidden;
}

.frisbuy-mobile-popup--video-mode {
  grid-template-rows: auto minmax(0, 1fr);
}

.frisbuy-mobile-popup__close {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  z-index: 5;
}

.frisbuy-mobile-popup__header {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0;
  padding: 8px 0;
  text-align: center;

  span:first-child {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);
  }

  span:last-child {
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
  }
}

.frisbuy-mobile-popup__media {
  position: relative;
  z-index: 1;
  width: 100%;
  min-width: 100%;
  min-height: 0;
  height: 100%;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  video {
    position: absolute;
    inset: 0;
  }
}

.frisbuy-mobile-popup__swiper,
.frisbuy-mobile-popup__slide {
  width: 100%;
  min-width: 100%;
  height: 100%;
}

.frisbuy-mobile-popup__swipe-hint {
  position: absolute;
  inset: 0;
  z-index: 7;
  pointer-events: none;
}

.frisbuy-mobile-popup__swipe-hint-block {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  transform: translate(-50%, -50%) translateX(60px);
  transform-origin: center center;
  animation: ReviewsModal_swipe 1.8s ease-in-out 1.6;
}

@keyframes ReviewsModal_swipe {
  0% {
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%) translateX(60px);
    opacity: 1;
  }

  25% {
    width: 80px;
    height: 40px;
    transform: translate(-50%, -50%) translateX(0);
    opacity: 1;
  }

  50% {
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%) translateX(-40px);
    opacity: 1;
  }

  75% {
    width: 0;
    height: 0;
    transform: translate(-50%, -50%) translateX(-40px);
    opacity: 0;
  }

  90% {
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%) translateX(60px);
    opacity: 0;
  }

  to {
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%) translateX(60px);
    opacity: 1;
  }
}

.frisbuy-mobile-popup__swiper :deep(.swiper-wrapper) {
  height: 100%;
}

.frisbuy-mobile-popup__media--video {
  background: transparent;
}

.frisbuy-mobile-popup__video-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.frisbuy-mobile-popup__video-overlay--video {
  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, #212121 100%);
}

.frisbuy-mobile-popup--video-mode .frisbuy-mobile-popup__media {
  position: absolute;
  left: 0;
  right: 0;
  top: 56px;
  bottom: 0;
  height: auto;
}

.frisbuy-mobile-popup__play-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, calc(-50% - 20px));
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 6;

  svg {
    display: block;
    width: 48px;
    height: 48px;
  }
}

.frisbuy-mobile-popup__bottom-layer {
  position: relative;
  z-index: 4;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, #212121 100%);
}

.frisbuy-mobile-popup__bottom-layer--video {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.frisbuy-mobile-popup__info {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: auto;
  max-height: none;
  overflow: hidden;
  overflow-x: hidden;
  padding: 0;
  transition: max-height 0.2s ease;
  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, #212121 100%);
}

.frisbuy-mobile-popup__info--video {
  margin-bottom: 67px;
  background: transparent;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review--modal-popup) {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  height: auto !important;
  min-height: 0 !important;
  color: #ffffff;
  background: transparent;
  overflow-x: hidden;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__top-section) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: nowrap;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-review-author--popup) {
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  gap: 8px !important;
  justify-content: flex-start !important;
}

.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__main) {
  gap: 0;
  flex: 0 0 auto;
}

.frisbuy-mobile-popup__info
  :deep(
    .frisbuy-review-author--popup .frisbuy-review-author__rating-mobile-stars
  ) {
  margin-left: 8px;
  flex: 0 0 auto;
}

.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__meta) {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.frisbuy-mobile-popup__info
  :deep(
    .frisbuy-customer-review--modal-popup
      .frisbuy-customer-review__content-main-modal-popup.frisbuy-customer-review__content-main-modal-popup--collapsed
  ) {
  max-height: none;
  overflow: visible;
}

.frisbuy-mobile-popup__info
  :deep(
    .frisbuy-customer-review--modal-popup
      .frisbuy-customer-review__content-main-modal-popup
  ) {
  padding: 16px;
}

.frisbuy-mobile-popup__info
  :deep(
    .frisbuy-customer-review--modal-popup
      .frisbuy-customer-review__content-main-modal-popup.frisbuy-customer-review__content-main-modal-popup--collapsed::after
  ) {
  display: none;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__read-more),
.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__read-more-gradient),
.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__avatar),
.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__date) {
  display: none;
}

.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__name),
.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__text),
.frisbuy-mobile-popup__info :deep(.frisbuy-review-author__rating-simple) {
  color: #ffffff;
}

.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author--popup .frisbuy-review-author__name) {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
}

.frisbuy-mobile-popup__info
  :deep(.frisbuy-review-author__rating-simple svg path) {
  fill: #ffffff;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__text) {
  margin-top: 8px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__text--positive),
.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__text--negative),
.frisbuy-mobile-popup__info :deep(.frisbuy-customer-review__text--comment) {
  display: inline;
}

.frisbuy-mobile-popup__open-review {
  display: inline-flex;
  border: 0;
  border-bottom: 1px dashed #ffffff;
  background: transparent;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  padding: 0;
  margin: 0;
}

.frisbuy-mobile-popup__info--video :deep(.frisbuy-mobile-media-slider),
.frisbuy-mobile-popup__info--video :deep(.frisbuy-customer-review--modal-popup),
.frisbuy-mobile-popup__info--video
  :deep(.frisbuy-customer-review.frisbuy-customer-review--modal-popup),
.frisbuy-mobile-popup__info--video
  :deep(.frisbuy-customer-review__content-main-modal-popup),
.frisbuy-mobile-popup__info--video :deep(.frisbuy-mobile-video-controls) {
  background: transparent !important;
  background-image: none !important;
}

.frisbuy-mobile-popup__info--video
  :deep(
    .frisbuy-customer-review--modal-popup
      .frisbuy-customer-review__content-main-modal-popup
  ) {
  padding: 16px 16px 5px;
}

@media (min-width: 1024px) {
  .frisbuy-mobile-popup {
    display: none;
  }
}
</style>
